// 报告 API 封装 / Reports API facade
import { api } from "@/api/client";

export interface ReportSummary {
  id: string;
  title: string;
  mode: string;
  source: string;
  created_at: string;
  simulation_id: string | null;
  viewer_url: string;
  schema_version?: string | null;
  grade?: string | null;
  confidence?: string | null;
  verdict_oneliner?: string | null;
  scorecard?: Array<Record<string, unknown>>;
  winner?: string | null;
}

export interface ReportDetail extends ReportSummary {
  ok: true;
  report_id: string;
  markdown: string;
  payload?: Record<string, unknown> | null;
  download_urls: { markdown: string; html?: string; pdf?: string };
}

export interface ReportPreviewRequest {
  theme?: string;
  reportMode?: string;
}

export interface ReportPreviewResponse {
  ok: true;
  etag: string;
  html: string;
  css?: string;
  head?: string;
  scripts?: string[];
  diagnostics?: Array<Record<string, unknown>>;
}

export const reportsApi = {
  list: () => api.get<{ ok: true; reports: ReportSummary[] }>("/api/v1/reports"),
  get: (id: string) => api.get<ReportDetail>(`/api/v1/reports/${id}`),
  preview: (id: string, body: ReportPreviewRequest) =>
    api.post<ReportPreviewResponse>(`/api/v1/reports/${id}/preview`, body),
  renderHtml: (id: string) =>
    api.post<{ ok: true; html_s3_key: string; html_etag: string }>(
      `/api/v1/reports/${id}/render-html`,
      {},
    ),
};
